// Avisos em massa a agentes contra o WootDash — /broadcasts. Substitui
// broadcastService.ts (n8n, N8N_BROADCAST_URL). Sem imagem/YouTube/link separados como
// o modelo antigo — Message.MediaUrl é só uma URL de mídia opcional (mesma simplificação
// já aplicada em outras portagens desta sessão).
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export type BroadcastKind = 'aviso' | 'relatorio' | 'ciclo'

export interface CpBroadcast {
  id: string
  senderId: string
  senderName: string
  /** aviso = escrito por um agente; relatorio = entrega automática do Relatório de Resolução. */
  kind: BroadcastKind
  body: string
  mediaUrl: string | null
  createdAt: string
  confirmedAt: string | null
}

async function get<T>(token: string, path: string, fallback: T): Promise<T> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}${path}`, { headers: wootdashAuthHeaders(token) })
    if (!res.ok) return fallback
    return await res.json()
  } catch {
    return fallback
  }
}

async function mutate(token: string, method: string, path: string, body?: unknown): Promise<{ ok: boolean; status: number; data?: any }> {
  const res = await fetch(`${WOOTDASH_BASE}${path}`, {
    method,
    headers: { ...wootdashAuthHeaders(token), ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  })
  const data = res.status !== 204 ? await res.json().catch(() => undefined) : undefined
  return { ok: res.ok, status: res.status, data }
}

/** Recebidos pelo agente logado. Sem tipo = todos (o popup de confirmação usa todos). */
export function listMyBroadcasts(token: string, kind?: BroadcastKind): Promise<CpBroadcast[]> {
  return get(token, kind ? `/broadcasts/minhas?tipo=${kind}` : '/broadcasts/minhas', [])
}

export interface SentBroadcastRecipient { agentId: string; name: string; avatarUrl: string | null; confirmedAt: string | null }
export interface SentBroadcast {
  id: string
  body: string
  mediaUrl: string | null
  createdAt: string
  total: number
  confirmed: number
  /** Quem ainda não confirmou vem primeiro. */
  recipients: SentBroadcastRecipient[]
}

/** Admin › Aviso a Agentes: os avisos que o agente logado enviou, com quem confirmou. null = falhou ao buscar. */
export async function listSentBroadcasts(token: string): Promise<SentBroadcast[] | null> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/broadcasts/enviados`, { headers: wootdashAuthHeaders(token) })
    return res.ok ? await res.json() : null
  } catch {
    return null
  }
}

export async function createBroadcast(token: string, body: string, mediaUrl: string | null, recipientAgentIds: string[]) {
  return mutate(token, 'POST', '/broadcasts', { body, mediaUrl, recipientAgentIds })
}

export async function confirmBroadcast(token: string, id: string) {
  return mutate(token, 'POST', `/broadcasts/${id}/confirmar`)
}
